import { render, staticRenderFns } from "./LorentzForceViz.vue?vue&type=template&id=27f6e331&scoped=true"
import script from "./LorentzForceViz.vue?vue&type=script&lang=js"
export * from "./LorentzForceViz.vue?vue&type=script&lang=js"
import style0 from "./LorentzForceViz.vue?vue&type=style&index=0&id=27f6e331&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f6e331",
  null
  
)

export default component.exports